var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.isMobile)?_c('DekstopReview'):_c('MobileReview')}
var staticRenderFns = []

export { render, staticRenderFns }